module.exports = __webpack_public_path__ + "img/metaquotes.1b2a128a.svg";